import styled from "styled-components";
import React from "react";
import { useTranslation } from 'react-i18next';
import FullscreenMediaViewer from './FullscreenMediaViewer';

const SliderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: min(790px, 90vh);
    position: relative;

    @media (max-width: 1000px) {
        height: 300px;
    }

    > img, > .spacer {
        width: 40px;
        margin: 0 20px;

        @media (max-width: 1000px) {
            width: 20px;
            margin: 0 10px;
        }
    }

    > img {
        cursor: pointer;
    }

    > div.slide {
        width: 100%;
        height: 100%;
        padding: 0 50px;
        display: flex;
        justify-content: center;
        align-items: center;

        @media (max-width: 1000px) {
            padding: 0 10px;
        }

        > img, > video {
            max-height: 100%;
            max-width: 100%;
            cursor: pointer;
        }

        > a {
            font-size: 16px;
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #000000AA;
            color: #fff;
            padding: 10px 20px;
            border-radius: 5px;
            backdrop-filter: blur(2px);
        }
    }
`


const DotIndicators = styled.div`
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;

    > div{
        width: 10px;
        height: 10px;
        margin: 0 5px;
        cursor: pointer;
        border-radius: 50%;
        background-color: #ddd;
        box-shadow: 0 0 5px #000;

        &.active{
            background-color: #888;
        }
    }
`

const Slider = (props) => {

    const [slideIndex, setSlideIndex] = React.useState(0);
    const [fullscreenOpen, setFullscreenOpen] = React.useState(false);
    const { i18n } = useTranslation('common');

    function nextSlide(){
        if(slideIndex < props.slides.length - 1){
            setSlideIndex(slideIndex + 1);
        } else {
            setSlideIndex(0);
        }
    }
    function previousSlide(){
        if(slideIndex > 0){
            setSlideIndex(slideIndex - 1);
        } else {
            setSlideIndex(props.slides.length - 1);
        }
    }

    const openFullscreen = () => {
        setFullscreenOpen(true);
    }

    const closeFullscreen = () => {
        setFullscreenOpen(false);
    }

    if (props.slides.length === 0) return null;

    const filePath = process.env.REACT_APP_MEDIA_BASE_URL + (props.slides[slideIndex].path.includes("milan2026/") ? "" : "userfiles/") + props.slides[slideIndex].path;

    // pdf file path looks like this : /userfiles/somekindofid.pdf
    // the image of the preview looks like this : /userfiles/firstpage_somekindofid.png
    const filename = filePath.split('/').pop();
    const pdfPreviewPath = filePath.replace(filename, "firstpage_" + filename).replace('.pdf', '.png');

    return (<>
        <SliderContainer style={props.height ? {height:props.height} : {}}>
            {slideIndex > 0 ? <img src="/img/fleche_noire_gauche.png" onClick={previousSlide} alt={i18n.language === "fr" ? "précedent" : "previous"}/> : <div className="spacer"/>}
            <div className='slide'>
                {props.slides[slideIndex].type.includes('image') &&
                    <img src={filePath} alt="" onClick={openFullscreen}/>
                }
                {props.slides[slideIndex].type.includes('video') &&
                    <video src={filePath} controls/>
                }
                {props.slides[slideIndex].type.includes('pdf') && <>
                    <img src={pdfPreviewPath} alt="" onClick={openFullscreen}/>
                    {!props.hideDocumentLink && (
                        <a href={filePath} target='_blank' rel='noreferrer'>
                            {i18n.language === "fr" ? "Voir le document" : "See the document"}
                        </a>
                    )}
                </>}
            </div>
            {slideIndex < props.slides.length - 1 ? <img src="/img/fleche_noire_droite.png" onClick={nextSlide} alt={i18n.language === "fr" ? "suivant" : "next"}/> : <div className="spacer"/>}
            {/* dot indicators */}
            {props.slides.length > 1 && <DotIndicators style={{display:"flex",justifyContent:"center",width:"100%"}}>
                {props.slides.map((_, i) =>
                    <div key={i} className={i === slideIndex ? "active" : ""} onClick={() => setSlideIndex(i)}></div>
                )}
            </DotIndicators>}
        </SliderContainer>
        {!props.hideLegend && (
            <>
                <br/>
                {props.slides[slideIndex].credit && <><span className='centered' style={{fontSize:"12px",color:"#888"}}>© {props.slides[slideIndex].credit}</span><br/></>}
                <span className='centered' >{props.slides[slideIndex].legende}</span>
            </>
        )}

        {/* Fullscreen Media Viewer */}
        <FullscreenMediaViewer 
            slides={props.slides}
            currentSlideIndex={slideIndex}
            isOpen={fullscreenOpen}
            onClose={closeFullscreen}
            onNext={nextSlide}
            onPrevious={previousSlide}
        />
    </>)
}

export default Slider;